import { Helmet } from 'react-helmet-async';

export default function SEOHead({
  title = 'Smed i Gribskov i Nordsjælland | Gribskovsmeden ApS',
  description = 'Professionel smed på Nordsjælland – vi specialiserer os i alt fra altaner og trapper til porte og stålkonstruktioner. Kontakt os i dag',
  image = 'https://assets.auxodev.dk/assets/a97cf6ea-7b79-4b87-946d-9f6d75bc924c/logo-10.png',
  canonicalUrl = window.location.href,
}) {
  return (
    <Helmet>
      <title>{title}</title>
      {description && <meta name="description" content={description} />}
      <meta property="og:title" content={title} />
      {description && <meta property="og:description" content={description} />}
      {image && <meta property="og:image" content={image} />}
      <meta property="og:type" content="website" />
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      {description && <meta name="twitter:description" content={description} />}
      {image && <meta name="twitter:image" content={image} />}
    </Helmet>
  );
}
